import merkUrl from '@/assets/configurewise-mark-blue.svg'
import { cn } from '@/lib/utils'

export function GemaaktDoor({ className }: { className?: string }) {
  return (
    <a
      href="https://www.configurewise.com"
      target="_blank"
      rel="noreferrer"
      className={cn(
        'group inline-flex items-center gap-1.5 text-[11px] text-ink-faint transition-colors duration-150 hover:text-ink-soft',
        className,
      )}
    >
      <span>Gemaakt door</span>
      <img
        src={merkUrl}
        alt=""
        className="h-4 w-auto shrink-0 select-none opacity-85 transition-opacity duration-150 group-hover:opacity-100"
      />
      <span className="font-medium">ConfigureWise</span>
    </a>
  )
}
